/**
 * Stap 0 van /nieuwe-aanvraag: dienstkeuze. Het Kleda/vloerkleed-pad is 100%
 * native (wasserij doen we zelf); overige diensten lopen via de booking-flow
 * iframe (die gaan naar partners).
 */
export function ServiceKeuze({ onPick }: { onPick: (view: 'kleda' | 'overig') => void }) {
  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-xl font-semibold text-slate-900 mb-1">Nieuwe aanvraag</h1>
      <p className="text-sm text-slate-600 mb-6">Wat wil de klant laten doen?</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <button
          onClick={() => onPick('kleda')}
          className="text-left p-5 bg-white border-2 border-slate-200 rounded-xl hover:border-indigo-400 transition-colors"
        >
          <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
            <svg className="w-5 h-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h10M4 18h6" />
            </svg>
          </div>
          <div className="text-base font-semibold text-slate-900">Vloerkleed reinigen</div>
          <div className="text-sm text-slate-500 mt-1">
            Kleda — ophalen, reinigen, terugbrengen. Bestaande klant koppelen, routes en prijs direct in beeld.
          </div>
        </button>
        <button
          onClick={() => onPick('overig')}
          className="text-left p-5 bg-white border-2 border-slate-200 rounded-xl hover:border-indigo-400 transition-colors"
        >
          <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center mb-3">
            <svg className="w-5 h-5 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <div className="text-base font-semibold text-slate-900">Overige diensten</div>
          <div className="text-sm text-slate-500 mt-1">
            Tapijt, meubels, matras, dakkapel, zonnepanelen — via de booking-flow.
          </div>
        </button>
      </div>
    </div>
  )
}
